import { EMAIL, FIRST_NAME, LAST_NAME } from '../fields'

export const getRepresentativeTitle = representative => {
  if (representative[LAST_NAME]) {
    return `${representative[FIRST_NAME]} ${representative[LAST_NAME]}`
  } else {
    return `${representative[FIRST_NAME]} ${representative[EMAIL]}`
  }
}
